/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Bundle_Yousave1Inputs */

const id_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda hemat:`)
};

const ms_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda jimat:`)
};

const da_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du sparer:`)
};

const de_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie sparen:`)
};

const en_us2_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You save:`)
};

const es_es2_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorras:`)
};

const es_mx2_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorras:`)
};

const fil_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matitipid mo:`)
};

const fr_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous économisez :`)
};

const it_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risparmi:`)
};

const hu_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megtakarítás:`)
};

const nl_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je bespaart:`)
};

const no_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du sparer:`)
};

const pl_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oszczędzasz:`)
};

const pt_br2_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You save:`)
};

const pt_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poupa:`)
};

const ro_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economisești:`)
};

const fi_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säästät:`)
};

const sv_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du sparar:`)
};

const vi_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn tiết kiệm:`)
};

const tr_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kazancınız:`)
};

const cs_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ušetříte:`)
};

const bg_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спестявате:`)
};

const ru_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы экономите:`)
};

const uk_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви економите:`)
};

const ar_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`توفير:`)
};

const hi_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप बचाते हैं:`)
};

const th_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณประหยัด:`)
};

const ja_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お得額：`)
};

const zh_cn2_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You save:`)
};

const zh_hant1_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You save:`)
};

const ko_components_bundle_yousave1 = /** @type {(inputs: Components_Bundle_Yousave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You save:`)
};

/**
* | output |
* | --- |
* | "You save:" |
*
* @param {Components_Bundle_Yousave1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_bundle_yousave1 = /** @type {((inputs?: Components_Bundle_Yousave1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Bundle_Yousave1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_bundle_yousave1(inputs)
	if (locale === "ms") return ms_components_bundle_yousave1(inputs)
	if (locale === "da") return da_components_bundle_yousave1(inputs)
	if (locale === "de") return de_components_bundle_yousave1(inputs)
	if (locale === "en-US") return en_us2_components_bundle_yousave1(inputs)
	if (locale === "es-ES") return es_es2_components_bundle_yousave1(inputs)
	if (locale === "es-MX") return es_mx2_components_bundle_yousave1(inputs)
	if (locale === "fil") return fil_components_bundle_yousave1(inputs)
	if (locale === "fr") return fr_components_bundle_yousave1(inputs)
	if (locale === "it") return it_components_bundle_yousave1(inputs)
	if (locale === "hu") return hu_components_bundle_yousave1(inputs)
	if (locale === "nl") return nl_components_bundle_yousave1(inputs)
	if (locale === "no") return no_components_bundle_yousave1(inputs)
	if (locale === "pl") return pl_components_bundle_yousave1(inputs)
	if (locale === "pt-BR") return pt_br2_components_bundle_yousave1(inputs)
	if (locale === "pt") return pt_components_bundle_yousave1(inputs)
	if (locale === "ro") return ro_components_bundle_yousave1(inputs)
	if (locale === "fi") return fi_components_bundle_yousave1(inputs)
	if (locale === "sv") return sv_components_bundle_yousave1(inputs)
	if (locale === "vi") return vi_components_bundle_yousave1(inputs)
	if (locale === "tr") return tr_components_bundle_yousave1(inputs)
	if (locale === "cs") return cs_components_bundle_yousave1(inputs)
	if (locale === "bg") return bg_components_bundle_yousave1(inputs)
	if (locale === "ru") return ru_components_bundle_yousave1(inputs)
	if (locale === "uk") return uk_components_bundle_yousave1(inputs)
	if (locale === "ar") return ar_components_bundle_yousave1(inputs)
	if (locale === "hi") return hi_components_bundle_yousave1(inputs)
	if (locale === "th") return th_components_bundle_yousave1(inputs)
	if (locale === "ja") return ja_components_bundle_yousave1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_bundle_yousave1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_bundle_yousave1(inputs)
	return ko_components_bundle_yousave1(inputs)
});
export { components_bundle_yousave1 as "components.bundle.youSave" }